<ng-template cxOutletRef="SiteContext" cxOutletPos="before">
  @if (customerContext$ | async; as customer) {
    @if (!['CwtOrderConfirmationPageTemplate', 'CwtMultiStepCheckoutSummaryPageTemplate'].includes(pageTemplateName)) {
      <div ngbDropdown class="customer-name">
        <span class="float-left pr-0 pl-0 font-size hover-link cursor-pointer customer-context d-flex ali align-items-center justify-content-end">
          <div class="soldto-current" [ngClass]="{ 'active': isActive }" (click)="toggle()">
            <span>{{ customer.customerNumber | removeLeadingZeros }} {{ customer.customerName }}</span>
          </div>
          <div class="soldto-dropdown" id="soldtoDropdown" [ngClass]="{ 'active': isActive }" (mouseleave)="closeSoldto()" (click)="toggle()">
            <div class="soldto-info">
              <div class="soldto-number">{{ customer.customerNumber | removeLeadingZeros }}</div>
              <div class="soldto-name">{{ customer.customerName }}</div>
            </div>
            <div class="soldto-actions">
              <button class="soldto-action-btn"
                [ngClass]="{ 'disable': this.soldToAccountsList?.length === 1 }"
                [disabled]="this.soldToAccountsList?.length === 1"
                (click)="changeCustomerContext()">
                🔄 Switch Account
              </button>
            </div>
          </div>
        </span>
      </div>
    }
  }

  @if (user$ | async; as user) {
    <div class="user-portal">
      <div class="user-avatar">{{ this.avatarName }}</div>
      <span class="user-text">{{ user.name }}</span>
    </div>
  }

  <button class="logout-btn" title="Logout" (click)="logout()">⭕</button>
</ng-template>

<ng-template cxOutletRef="cx-header">
  @if (isLoginPage$ | async) {
    <cx-global-message></cx-global-message>
  } @else {
    <header class="main-header">
      <cx-page-layout section="header"></cx-page-layout>
    </header>

    <header class="header">
      @if (pageTemplateName !== 'CwtLoginPageTemplate') {
        <div class="header-bottom">
          <!-- <div class="isOrderConfirmationContainer" *ngIf="isOrderConfirmation">
            <cx-page-slot position="SiteLogo"></cx-page-slot>
            <div class=""><a class="nav-link">Support</a></div>
          </div> -->

          <div class="header-bottom-container">
            <cx-page-slot position="SiteLogo"></cx-page-slot>
            <cx-page-slot position="NavigationBar"></cx-page-slot>

            @if (isOrderConfirmation) {
              <div><a class="nav-link">Support</a></div>
            }

            @if (!isOrderConfirmation) {
              <div class="header-right">
                <cx-page-slot position="SearchBox"></cx-page-slot>

                @if ({ quantity: quantity$ | async }; as data) {
                  @if (!this.isCheckout && !hideCart) {
                    <div class="mini-cart-container" (mouseenter)="showMiniCart()" (mouseleave)="hideMiniCart()">
                      <div class="cart-icon-wrapper">
                        <div class="cart-icon" (click)="showCartPage(data?.quantity)">
                          <svg viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4m1.6 8L6 9H3m4 4v6a1 1 0 001 1h8a1 1 0 001-1v-6m-9 0h8"/>
                            <circle cx="9" cy="20" r="1"/>
                            <circle cx="20" cy="20" r="1"/>
                          </svg>
                          <span class="cart-count" id="cartCount">{{ data?.quantity ? data?.quantity : 0 }}</span>
                        </div>

                        @if (isOpenMiniCartDropdown) {
                          @if (data?.quantity > 0) {
                            <div class="mini-cart-dropdown">
                              <div class="cart-header">
                                Shopping Cart
                              </div>

                              @if (data?.quantity === 0) {
                                <div class="cart-items" id="cartItems">
                                  <div class="empty-cart">
                                    <div class="empty-cart-icon">🛒</div>
                                    <p>Your cart is empty</p>
                                  </div>
                                </div>
                              }

                              @for (item of this.cartEntries$ | async; track $index) {
                                <div>
                                  <div class="cart-item">
                                    <div class="cart-item-image">
                                      <cx-media
                                        [container]="item.product?.images?.PRIMARY"
                                        [format]="'cartIcon'"
                                        [alt]="item?.product?.images?.altText">
                                      </cx-media>
                                    </div>
                                    <div class="cart-item-details">
                                      <div class="cart-item-header">
                                        <div class="cart-item-name">{{ item?.product?.name }}</div>
                                        <div class="cart-item-price">{{ item?.totalPrice?.formattedValue }}</div>
                                      </div>
                                      <div class="cart-item-qty">Qty: {{ item?.quantity }}</div>
                                    </div>
                                  </div>
                                </div>
                              }

                              <div class="cart-total" id="cartTotal">
                                <div class="cart-total-row">
                                  <span>Subtotal:</span>
                                  <span id="subtotal">{{ subTotal$ | async }}</span>
                                </div>
                                <div class="cart-total-row total">
                                  <span>Total:</span>
                                  <span id="total">{{ total$ | async }}</span>
                                </div>
                              </div>

                              <div class="cart-actions" id="cartActions">
                                <button class="go-to-cart-btn" (click)="goToLocation('/cwtcart-detail')">
                                  Go to Cart
                                </button>
                              </div>
                            </div>
                          }
                        }
                      </div>

                      <div class="cart-text">Cart</div>
                    </div>
                  }

                  @if (this.isCheckout) {
                    <button class="edit-cart-btn" (click)="goToLocation('/cwtcart-detail')">
                      Edit Cart ({{ data?.quantity ? data?.quantity : 0 }})
                    </button>
                  }
                }
              </div>
            }
          </div>
        </div>
      }
    </header>

    <cx-page-slot position="BottomHeaderSlot" class="cx-bottom-header-slot"></cx-page-slot>
    <cx-global-message></cx-global-message>
  }
</ng-template>